/* eslint-disable max-len */

import React from 'react';
import { Svg, Path, G } from '@react-pdf/renderer';

export const ClosingDinnerIcon: React.FC = () => {
  return (
    <Svg width={42} height={42}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M37.246 0c0 2.89 1.756 4.023 3.134 4.468l.261.077.126.033.241.055.114.023.212.036.274.036.309.024.083.002v32.492c-2.89 0-4.023 1.756-4.468 3.134l-.077.261a6.125 6.125 0 0 0-.033.126l-.055.241a6.301 6.301 0 0 0-.023.114l-.036.212-.036.274-.024.309-.002.083H4.754c0-2.89-1.756-4.023-3.134-4.468l-.261-.077a6.125 6.125 0 0 0-.126-.033l-.241-.055a6.3 6.3 0 0 0-.114-.023l-.212-.036-.274-.036-.309-.024L0 37.246V4.754c2.89 0 4.023-1.756 4.468-3.134l.077-.261.033-.126.055-.241a6.3 6.3 0 0 0 .023-.114l.036-.212.036-.274.024-.309L4.754 0h32.492Zm-.782.827H5.503l-.04.237a6.454 6.454 0 0 1-.648 1.846c-.756 1.398-2 2.332-3.756 2.595l-.232.03v30.961l.237.041a6.454 6.454 0 0 1 1.846.648c1.398.756 2.332 2 2.595 3.756l.03.232h30.96l.042-.237a6.454 6.454 0 0 1 .648-1.846c.756-1.398 2-2.332 3.756-2.595l.232-.031V5.504l-.237-.041a6.454 6.454 0 0 1-1.846-.648c-1.398-.756-2.332-2-2.595-3.756l-.031-.232Z"
          fill="#CCCBCB"
          fillRule="nonzero"
        />
        <Path d="M5 5h32v32H5z" />
        <Path
          d="m16.008 22.801 3.7-3.826-8.093-8.357a1.293 1.293 0 0 0-2.105.365c-.929 2.015-.589 4.49 1.02 6.166l5.478 5.652Zm8.865-2.447c2 .96 4.811.284 6.89-1.866 2.497-2.583 2.981-6.288 1.06-8.276-1.91-1.974-5.492-1.487-8.003 1.096-2.079 2.15-2.732 5.057-1.804 7.126L11.183 30.67a1.38 1.38 0 0 0 0 1.906c.51.528 1.334.528 1.844 0l8.08-8.329 8.08 8.356c.51.528 1.334.528 1.844 0a1.38 1.38 0 0 0 0-1.906l-8.08-8.357 1.922-1.987Z"
          fill="#575B65"
          fillRule="nonzero"
        />
      </G>
    </Svg>
  );
};
